import { render, staticRenderFns } from "./SelectButtonArea.vue?vue&type=template&id=256920a0&scoped=true&"
import script from "./SelectButtonArea.vue?vue&type=script&lang=js&"
export * from "./SelectButtonArea.vue?vue&type=script&lang=js&"
import style0 from "./SelectButtonArea.vue?vue&type=style&index=0&id=256920a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256920a0",
  null
  
)

export default component.exports